const PDF_PAGE = require('../enums/PDFPage');

const checkIfPhotoIsFullBleed = ({ imageWidth, imageHeight }) => {
  const pageRatio = PDF_PAGE.WIDTH / PDF_PAGE.HEIGHT;
  const photoRatio = imageWidth / imageHeight;
  const ratioDiff = Math.abs(100 - (photoRatio * 100 / pageRatio));
  return ratioDiff <= 5;
};

module.exports = checkIfPhotoIsFullBleed;
